<template>
  <div class="form">
    <h1 class="extra-large-headline">{{ formTitle }}</h1>
    <p class="bodycopy">
      {{ formDescription }}
    </p>
    <form @submit.prevent>
      <component
        :is="loadDynamicFormPath"
        @payment-complete="handleFormRedirect"
        @payment-failed="handleFailureRedirect"
      />
    </form>
  </div>
</template>

<script setup>
import { ref, defineAsyncComponent, computed } from "vue";
import { useRouter } from "vue-router";

import { useGlobalStore } from "@/stores/globalStore";
import { useOrderFormStore } from "@/stores/forms/orderFormStore";

import { capitaliseFirstChar } from "@/composables/helpers/useStringHelpers.js";

const orderStore = useOrderFormStore();
const globalStore = useGlobalStore();
const router = useRouter();
const form = ref({
  payment: orderStore.getPaymentProvider?.paymentType,
});

const loadDynamicFormPath = computed(() => {
  const payment = capitaliseFirstChar(form.value.payment.toLowerCase());
  return defineAsyncComponent(() =>
    import(/* @vite-ignore */ `./Payments/${payment}/${payment}Form.vue`)
  );
});

const formTitle = orderStore.isBuyMode ? "Payment details" : "Deposit details";
const formDescription = orderStore.isBuyMode
  ? "Complete the below to securely finalize your transaction."
  : "";

const handleFormRedirect = (orderId) => {
  if (orderStore.getOrderType === "CRYPTO-SELL") {
    router.push(`/coindeposit/${orderId}`);
    return;
  }
  if (orderStore.getOrderType === "NFT-BUY") {
    router.push(`/nft/status/${orderId}`);
    return;
  }
  router.push(`/status/${orderId}`);
};

const handleFailureRedirect = (routeName = "") => {
  const merchRedirectUrl = globalStore.merchant.returnUrl;

  if (merchRedirectUrl) {
    window.location = merchRedirectUrl;
  } else if (routeName) {
    router.push(routeName);
  } else {
    router.push("/");
  }
};
</script>
<style lang="scss"></style>
